import axios from "@/util/axios";
import Alert from "@/classes/Alert";

export default {
    methods:{

        validateEmailAddress(){
            axios.post(`/user-email-status`, {email: this.form.email})
                .then(response => {
                })
                .catch(errors => {
                    let response = errors.response.data;
                    Alert.warning(response.message, {
                        showCancelButton: false,
                        showCloseButton: true,
                        showConfirmButton: false,
                    })
                })
        },

        addAbandonedListener() {
            window.addEventListener('beforeunload', this.submitMixPanelAbandoned, {capture: true});
        },

        removeAbandonedListener(){
            window.removeEventListener('beforeunload', this.submitMixPanelAbandoned, {capture: true})
        },

        saveAbandoned(){
            // TODO in each Form
        },

        submitMixPanelAbandoned(){
            // TODO in each FORM
        },
    }
}
